import * as everything from './index';
for (const [key, value] of Object.entries(everything)) {
    // @ts-ignore
    window[key] = value;
}
